import http from "../../../../util/axios";

export default {
  //查询学员待办列表
  queryUserSchedules() {
    return http.get("/app/user/queryUserSchedules");
  },

  //查询课程评价
  courseAssess(params) {
    return http.get("/app/user/classCourse/courseAssess", { params });
  },

  //提交课程评价
  submitCourseAssess(data) {
    return http.post("/app/user/submitCourseAssess", data);
  },

  //查询项目学员评价
  queryLearnAppraise() {
    return http.get("/app/user/queryLearnAppraise");
  },

  //提交项目评价
  submitLearnAppraise(data) {
    return http.post("/app/user/submitLearnAppraise", data);
  },

  //查询项目反馈
  queryLearnFeedback() {
    return http.get("/app/user/queryLearnFeedback");
  },

  //提交项目反馈
  submitLearnFeedback(data) {
    return http.post("/app/user/submitLearnFeedback", data);
  },

  //查询报表报告
  queryLearnReport() {
    return http.get("/app/user/queryLearnReport");
  },

  //提交报表报告
  submitLearnReport(data) {
    return http.post("/app/user/submitLearnReport", data);
  },

  //查询供应商服务质量评价
  queryLearnSupplier() {
    return http.get("/app/user/queryLearnSupplier");
  },

  //提交供应商服务质量评价
  submitLearnSupplier(data) {
    return http.post("/app/user/submitLearnSupplier", data);
  }
};



// WEBPACK FOOTER //
// ./src/api/user/course/todolist/index.js